const AIAnalyzing = () => {
    return (
        <div className="mt-8 flex flex-col items-center justify-center py-24">

            {/* AI Circle */}
            <div className="relative">
                <div className="h-20 w-20 rounded-full bg-blue-100 animate-ping absolute"></div>

                <div className="relative h-20 w-20 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center shadow-xl">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-10 w-10 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9.75 17L15 12l-5.25-5"
                        />
                    </svg>
                </div>
            </div>

            {/* Text */}
            <h2 className="mt-8 text-2xl font-bold text-gray-800">
                AI is analysing your data
            </h2>

            <p className="mt-2 text-gray-500">
                Generating charts, KPIs and insights
            </p>

            {/* Animated Dots */}
            <div className="flex gap-2 mt-6">
                <span className="w-3 h-3 rounded-full bg-blue-500 animate-bounce"></span>
                <span
                    className="w-3 h-3 rounded-full bg-blue-500 animate-bounce"
                    style={{ animationDelay: "0.15s" }}
                ></span>
                <span
                    className="w-3 h-3 rounded-full bg-blue-500 animate-bounce"
                    style={{ animationDelay: "0.3s" }}
                ></span>
            </div>
        </div>
    );
};

export default AIAnalyzing;